import I18n from 'i18n-js';
import React from 'react';
import ListingsCollection from '@reverbdotcom/commons/src/components/listings_collection';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import {
  CPRecommendationsRowQuery,
  CpListingsRecommendations,
  useRecommendedListingsTracking,
  COMPONENT_NAME,
  MIN_COUNT,
} from './recommended_listings_common';
import { userContextIsTrackable } from '@reverbdotcom/commons/src/elog/mparticle';
import { EVERYWHERE_CODE } from '@reverbdotcom/commons/src/constants';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { reverb_search_ListingsSearchRequest_Sort } from '@reverbdotcom/commons/src/rql';

interface ExternalProps {
  limit?: number;
  newHomepageDesign?: boolean;
}

export default function CPRecommendationsListingsRow(props: ExternalProps) {
  const user = useUser();

  const { data, loading } = useQuery<CpListingsRecommendations.Query, CpListingsRecommendations.Variables>(
    CPRecommendationsRowQuery,
    {
      // Ignore sticky seller location on Homepage.
      context: {
        headers: {
          'X-Item-Region': EVERYWHERE_CODE,
        },
      },
      ssr: false,
      variables: {
        limit: props.limit,
        shouldSkipTracking: !userContextIsTrackable(user),
        sort: reverb_search_ListingsSearchRequest_Sort.PUBLISHED_AT_DESC,
      },
    },
  );
  const listings = data?.cpToListingRecs?.searchResponse?.listings || [];
  const recommendationEngineInputIds =  data?.cpToListingRecs?.recommendationEngineInputIds || [];
  const recommendationEngineOutputIds =  data?.cpToListingRecs?.recommendationEngineOutputIds || [];

  useRecommendedListingsTracking(user, loading, listings.map(listing => listing.id), recommendationEngineInputIds, recommendationEngineOutputIds);
  if (
    !loading &&
      listings.length < MIN_COUNT
  ) {
    return null;
  }

  return (
    <ListingsCollection
      componentName={COMPONENT_NAME}
      listings={listings}
      loading={loading}
      title={I18n.t('discovery.recommendedListings.cpRecommendationsTitle')}
      largeTiles={!props.newHomepageDesign}
    />
  );
}
